import * as MutationTypes from './mutationTypes';

// Normal notifications
const addNotification = (state, notification) => {
  state.notifications.push(notification);
};
const removeNotification = (state, numNotificationsToRemove) => {
  state.notifications.splice(0, numNotificationsToRemove);
};
const dismissNotifications = (state) => {
  state.notifications = [];
};

// Persistent notifications
const addPersistentNotification = (state, notification) => {
  state.persistentNotifications.push(notification);
};

const removePersistentNotificationById = (state, id) => {
  state.persistentNotifications = state.persistentNotifications.filter((el) => el.id !== id);
};

const dismissPersistentNotifications = (state) => {
  state.persistentNotifications = [];
};

export const mutations = {
  // Normal notifications
  [MutationTypes.ADD_NOTIFICATION]: addNotification,
  [MutationTypes.REMOVE_NOTIFICATION]: removeNotification,
  [MutationTypes.DISMISS_NOTIFICATIONS]: dismissNotifications,

  // Persistent notifications
  [MutationTypes.ADD_PERSISTENT_NOTIFICATION]: addPersistentNotification,
  [MutationTypes.REMOVE_PERSISTENT_NOTIFICATION_BY_ID]: removePersistentNotificationById,
  [MutationTypes.DISMISS_PERSISTENT_NOTIFICATIONS]: dismissPersistentNotifications,
};
